import { cn } from '@ngg/storefront-utils';
import Link from '@ui/components/Link/Link';
import { usePathname } from 'next/navigation';
import Icon from '@ui/components/icon/icon';
import {
  NavigationLastLevelSublinkFragment,
  NavigationSublinkFragment,
} from '@business/gql/graphql';

type MobileSubMenuLinkProps = {
  link?: NavigationLastLevelSublinkFragment | NavigationSublinkFragment | null;
  locale: string;
  onClose: () => void;
  onClick?: (id: string) => Promise<void>;
};

export default function MobileSubMenuLink({
  link,
  onClose,
  locale,
  onClick,
}: MobileSubMenuLinkProps) {
  const pathname = usePathname();

  if (!link) return null;

  const isCurrentPage =
    link?.internalLink && pathname.endsWith(link?.internalLink?.slug || '');

  const buttonAndLinkClassName = cn(
    'flex w-full items-center justify-between px-4 py-3 text-left first:pt-0',
    isCurrentPage && 'underline',
  );

  if (link.sublinksCollection?.total && link.sublinksCollection?.total > 0)
    return (
      <div>
        <Link
          className={buttonAndLinkClassName}
          href={link?.internalLink?.slug || ''}
          target={link?.openInNewTab ? '_blank' : undefined}
          onClick={async (event) => {
            event.preventDefault();
            if (onClick) {
              await onClick(link.sys?.id);
            }
          }}>
          {link.title}
          <Icon name="rightArrow" color="black" size={12} />
        </Link>
      </div>
    );

  return (
    <div>
      <Link
        className={buttonAndLinkClassName}
        locale={locale}
        href={link?.internalLink?.slug || ''}
        target={link?.openInNewTab ? '_blank' : undefined}
        onClick={() => onClose()}>
        {link.title}
      </Link>
    </div>
  );
}
